import { render, staticRenderFns } from "./SamlSuccess.vue?vue&type=template&id=533f7ad4&scoped=true&"
import script from "./SamlSuccess.vue?vue&type=script&lang=js&"
export * from "./SamlSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SamlSuccess.vue?vue&type=style&index=0&id=533f7ad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f7ad4",
  null
  
)

export default component.exports